import React, { FC } from 'react';
import { cn } from '@bem-react/classname';
import { YAText } from '@ui-kit';
import { IMediaProps } from './Media.types';
import 'react-gallery-carousel/dist/index.css';
import './Media.styles.scss';
import { ChainPNG } from '@assets/app';

const CnWorkMedia = cn('work-media');

const Media: FC<IMediaProps> = (props) => {
  const { media, isSmall, id } = props;

  return (
    <div className={CnWorkMedia({ isSmall })}>
      {media?.map((item, index) => (
        <div className={CnWorkMedia('content')}>
          <img src={ChainPNG} className={CnWorkMedia('chain')} alt={'chain'} />
          <YAText
            key={`${item.label}${index}${id}`}
            type={'H5'}
            isBold
            className={CnWorkMedia('text')}
            text={`${item.label}: ${item.value}`}
            onClick={(event) => {
              event.stopPropagation();
              event.preventDefault();
              window.open(item.link, '_blank');
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default Media;
